import { useEffect, useState } from 'react';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink, TabNav, Tab } from '../../components/Tab/Tabs';
import { introduceTabData } from '../../components/Tab/TabData';
import { fetchGet } from '../../hooks/fetch';
import Loading from '../Loading';

export default function IpStartup() {
	const [isLoading, setIsLoading] = useState(true);
	const [post, setPost] = useState({});
	const [activeTab, setActiveTab] = useState('');
	const [selectedTab, setSelectedTab] = useState(0);

	const selectTabHandler = (index) => {
		setSelectedTab(index);
	};

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '지식재산권과 창업';

	
	function getPage() {
		fetchGet(
			`/introduction/knowledge?type=${tabsData[selectedTab]?.type}`,
			(json) => {
				setPost(json.response);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, [selectedTab]);

	return (
		<main id="introduce-page-wrap" className="intellectual-property-page">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={introduceTabData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div className={`gs-nav-tab-con gs-sub-tab-con wrap`}>
						<TabNav tabsNumber={tabsData.length} selectedIndex={selectedTab}>
							{tabsData?.map((tab, i) => (
								<Tab
									key={i}
									id={tab.id}
									className={i === selectedTab ? 'gs-tab-item active' : 'gs-tab-item'}
									onClick={() => selectTabHandler(i)}
									tabIndex={i === selectedTab ? null : '-1'}
									ariaSelected={i === selectedTab ? 'true' : 'false'}
									title={tab.title}
								/>
							))}
						</TabNav>
						<div className="gs-tab-content">
							{isLoading ? <Loading />
								:
								<div
									id={`tabpanel-${tabsData[selectedTab]?.id}`}
									className="gs-tab-pane"
									role="tabpanel"
									aria-labelledby={`tab-${tabsData[selectedTab]?.id}`}
									dangerouslySetInnerHTML={{ __html: post?.content }}
								/>
							}
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}

const tabsData = [
	{
		id: 'intellectual-property-1',
		title: '지식재산권과 직무',
		type: 'KNOWLEDGE',
		// content: <Knowledge />,
	},
	{
		id: 'intellectual-property-2',
		title: '출원등록절차',
		type: 'APPLICATION',
		// content: <Application />,
	},
	{
		id: 'intellectual-property-3',
		title: '기술료와 발명자 보상',
		type: 'REWARD',
		// content: <Reward />,
	},
	{
		id: 'intellectual-property-4',
		title: '기술이전과 절차',
		type: 'RELOCATION',
		// content: <Relocation />,
	},
	{
		id: 'intellectual-property-5',
		title: '창업절차',
		type: 'STARTUP',
		// content: <Startup />,
	},
];
